import { PIXEL_TO_REM_RATIO, REM_STANDARD_WIDTH } from '../constants/default.mjs';

function px2remValue(value) {
  return Math.round(value * PIXEL_TO_REM_RATIO * 1000) / 1000;
}
function px2rem(value) {
  if (value === 0) {
    return "0";
  }
  if (Math.abs(value) <= 1) {
    return "".concat(value, "px");
  }
  return "".concat(px2remValue(value), "rem");
}
function makeViewportValue() {
  return 100 / PIXEL_TO_REM_RATIO / REM_STANDARD_WIDTH;
}
function standardPixelConvert(pixel) {
  var _a;
  var windowWidth = (_a = window.innerWidth) !== null && _a !== void 0 ? _a : REM_STANDARD_WIDTH;
  var ratio = windowWidth / REM_STANDARD_WIDTH;
  return ratio * pixel;
}
function rem2px(value) {
  var windowFontSize = "10px";
  requestAnimationFrame(function () {
    windowFontSize = window.getComputedStyle(document.documentElement).fontSize;
  });
  var standardPixel = parseFloat(windowFontSize !== null && windowFontSize !== void 0 ? windowFontSize : "10px");
  return value * standardPixel;
}

export { makeViewportValue, px2rem, px2remValue, rem2px, standardPixelConvert };
